import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dotSeparator'
})
export class DotSeparatorPipe implements PipeTransform {

  transform(value: number | string, locale?: string): string {
    return new Intl.NumberFormat(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(Number(value));
  }
}